import api from '../index';

export const GetBlogList = (data) => api.post('bloglist',data);
export const AddUpdateBlog = (data, header) => api.post('addupdateblog', data ,header);
export const DeleteBlog = (data) => api.post('deleteblog', data);
export const UpdateBlogStatus = (data) => api.post('changeblogstatus', data);